import { AvatarIcon } from "@wexinc/wex-ui";
import classnames from "classnames";

interface Props {
  text?: string;
  className?: string;
}

const Avatar: React.FC<Props> = (props) => {
  return props.text ? (
    <span
      className={classnames(
        "h-[30px] w-[30px] font-semibold text-[11px] rounded-full bg-primary-50 text-utility-white border border-utility-white flex items-center justify-center",
        props.className,
      )}
    >
      {props.text}
    </span>
  ) : (
    <AvatarIcon className={props.className} />
  );
};

export default Avatar;
